(() => {
  'use strict';

  const initQuantityBreaks = (root) => {
    if (!root || root.dataset.qbInitialized === 'true') return;

    root.dataset.qbInitialized = 'true';

    const offers = Array.from(
      root.querySelectorAll('[data-offer]')
    );

    if (!offers.length) return;


    /* =====================================================
       HELPERS
    ===================================================== */

    const getVariantData = (select) => {
      const option = select.options[select.selectedIndex];

      if (!option) {
        return {
          id: null,
          price: 0,
          compareAtPrice: 0,
          available: false
        };
      }

      return {
        id: option.value,
        price: Number(option.dataset.price || 0),
        compareAtPrice: Number(
          option.dataset.compareAtPrice || 0
        ),
        available: option.dataset.available === 'true'
      };
    };


    const formatMoney = (cents) => {
      const numericCents = Number(cents || 0);
      const amount = Math.floor(numericCents / 100);

      return `${amount} ${root.dataset.currency || 'RON'}`;
    };


    const roundCents = (value) => Math.round(value);


    /* =====================================================
       DISPLAY DISCOUNT
    ===================================================== */

    const getBundleMultiplier = (quantity) => {
      if (quantity === 1) return 0.516;
      if (quantity === 2) return 0.458;
      if (quantity === 3) return 0.3986666667;

      return 1;
    };


    /* =====================================================
       CALCULATE OFFER
    ===================================================== */

    const calculateOffer = (offer) => {
      const quantity = Number(
        offer.dataset.quantity || 1
      );

      const selects = Array.from(
        offer.querySelectorAll('[data-variant-select]')
      );

      let currentTotal = 0;
      let compareTotal = 0;
      let finalPrice = 0;

      let hasComparePrice = true;

      const multiplier =
        getBundleMultiplier(quantity);

      /*
        Shopify-style rounding:
        calculate the discount separately
        for each selected unit, then add
        the final prices together.
      */

      selects.forEach((select) => {
        const variant = getVariantData(select);

        currentTotal += variant.price;

        /*
          Original compare-at total
        */

        if (variant.compareAtPrice > 0) {
          compareTotal += variant.compareAtPrice;
        } else {
          hasComparePrice = false;
        }

        /*
          Calculate discount per unit.
        */

        const discountRate = 1 - multiplier;

        const discountCents = Math.floor(
          variant.price * discountRate
        );

        const finalVariantPrice =
          variant.price - discountCents;

        finalPrice += finalVariantPrice;
      });

      return {
      quantity,
      currentTotal,
      compareTotal: currentTotal,
      finalPrice,
      finalComparePrice: currentTotal,
      hasComparePrice: true
      };
    };


    /* =====================================================
       UPDATE OFFER UI
    ===================================================== */

    const updateOffer = (offer) => {
      const result = calculateOffer(offer);

      const priceElement =
        offer.querySelector('[data-current-price]');

      const compareElement =
        offer.querySelector('[data-compare-price]');

      const unitPriceElement =
        offer.querySelector('[data-unit-price]');


      if (priceElement) {
        priceElement.textContent =
          formatMoney(result.finalPrice);
      }


      if (compareElement) {
        if (
          result.hasComparePrice &&
          result.finalComparePrice > result.finalPrice
        ) {
          compareElement.textContent =
            formatMoney(result.finalComparePrice);

          compareElement.hidden = false;
        } else {
          compareElement.textContent = '';
          compareElement.hidden = true;
        }
      }


      if (
        unitPriceElement &&
        result.quantity > 1
      ) {
        unitPriceElement.textContent =
          `(${formatMoney(
            roundCents(
              result.finalPrice /
              result.quantity
            )
          )} / pcs)`;
      }
    };


    /* =====================================================
       CURRENT SELECTION
    ===================================================== */

    const getCurrentSelection = () => {
      const radio =
        root.querySelector(
          '[data-offer] .quantity-breaks__radio-input:checked'
        );

      if (!radio) return null;

      const offer =
        radio.closest('[data-offer]');

      if (!offer) return null;

      const quantity =
        Number(offer.dataset.quantity || 1);

      const selects = Array.from(
        offer.querySelectorAll('[data-variant-select]')
      );

      const variants = selects
        .map(getVariantData)
        .filter((variant) => variant.id);

      let discountCode = null;
      if (quantity === 1) {
  discountCode = '48%OFF';
      }

      if (quantity === 2) {
        discountCode = '54%OFF';
      }

      if (quantity === 3) {
        discountCode = '60%OFF';
      }

      return {
        quantity,
        discountCode,
        productId: root.dataset.productId,
        variants
      };
    };


    /* =====================================================
       PUBLISH SELECTION
    ===================================================== */

    const publishSelection = () => {
      const selection =
        getCurrentSelection();

      if (!selection) return;

      window.quantityBreaksSelection =
        selection;

      root.quantityBreaksSelection =
        selection;

      root.dispatchEvent(
        new CustomEvent(
          'quantitybreaks:change',
          {
            bubbles: true,
            detail: selection
          }
        )
      );
    };


    /* =====================================================
       UPDATE EVERYTHING
    ===================================================== */

    const updateAll = () => {
      offers.forEach(updateOffer);
      publishSelection();
    };


    /* =====================================================
       EVENTS
    ===================================================== */

    offers.forEach((offer) => {
      const radio =
        offer.querySelector(
          '.quantity-breaks__radio-input'
        );

      if (radio) {
        radio.addEventListener(
          'change',
          updateAll
        );
      }


      const selects =
        offer.querySelectorAll(
          '[data-variant-select]'
        );

      selects.forEach((select) => {
        select.addEventListener(
          'change',
          () => {
            updateOffer(offer);

            if (radio && radio.checked) {
              publishSelection();
            }
          }
        );
      });
    });


    /* =====================================================
       CART
    ===================================================== */

    const addToCart = async (items) => {
      const response =
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            'Accept':
              'application/json'
          },
          body: JSON.stringify({
            items
          })
        });

      if (!response.ok) {
        const errorText =
          await response.text();

        throw new Error(
          errorText ||
          'Nu am putut adauga produsele in cos.'
        );
      }

      return response.json();
    };


    /* =====================================================
       BUILD CART ITEMS
    ===================================================== */

    const buildCartItems = (selection) => {
      const grouped = {};

      selection.variants.forEach((variant) => {
        const id = String(variant.id);

        if (!grouped[id]) {
          grouped[id] = {
            id: Number(id),
            quantity: 0
          };
        }

        grouped[id].quantity += 1;
      });

      return Object.values(grouped);
    };

    /* =====================================================
       CLEAR CART WHEN RETURNING TO PRODUCT PAGE
    ===================================================== */

    const clearCartOnReturn = async () => {
      try {
        const response =
          await fetch('/cart.js', {
            credentials: 'same-origin'
          });

        if (!response.ok) return;

        const cart =
          await response.json();

        if (!cart || cart.item_count === 0) {
          return;
        }

        await fetch('/cart/clear.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type':
              'application/json'
          }
        });

      } catch (error) {
        console.warn(
          '[Quantity Breaks] Cart clear failed',
          error
        );
      }
    };
    let cartResetPromise = clearCartOnReturn();

    /*
      Back / Forward navigation.
      Covers browser bfcache restore.
    */

window.addEventListener(
  'pageshow',
  (event) => {
    if (event.persisted) {
      cartResetPromise = clearCartOnReturn();

      const productId =
        root.dataset.productId;

      if (productId) {
        const button =
          document.querySelector(
            `button[data-product-id="${productId}"]`
          );

        if (button) {
          button.dataset.qbProcessing = 'false';
        }
      }
    }
  }
);


    /*
      Returning to the browser tab/app.
    */
document.addEventListener(
  'visibilitychange',
  () => {
    if (
      document.visibilityState === 'visible'
    ) {
      cartResetPromise = clearCartOnReturn();

      const productId =
        root.dataset.productId;

      if (productId) {
        const button =
          document.querySelector(
            `button[data-product-id="${productId}"]`
          );

        if (button) {
          button.dataset.qbProcessing = 'false';
        }
      }
    }
  }
);


    /* =====================================================
       PAGEFLY BUY NOW
    ===================================================== */

    const setupPageFlyBuyNow = () => {
      const productId =
        root.dataset.productId;

      if (!productId) return;


      const selector =
        `button[data-product-id="${productId}"]`;


      document.addEventListener(
        'click',
        async (event) => {
          const button =
            event.target.closest(selector);

          if (!button) return;


          /*
            STOP PAGEFLY'S NORMAL BUY NOW
          */

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();


          if (
            button.dataset.qbProcessing === 'true'
          ) {
            return;
          }

          button.dataset.qbProcessing = 'true';


          try {
            const selection =
              getCurrentSelection();


            if (!selection) {
              throw new Error(
                'Selectează o ofertă.'
              );
            }


            if (
              selection.variants.length !==
              selection.quantity
            ) {
              throw new Error(
                'Selectează toate variantele pentru ofertă.'
              );
            }


            const unavailable =
              selection.variants.find(
                (variant) =>
                  !variant.available
              );

            if (unavailable) {
              throw new Error(
                'Una dintre variantele selectate nu este disponibilă.'
              );
            }


            const items =
              buildCartItems(selection);
          

      await addToCart(items);

if (selection.discountCode) {
  window.location.href =
    `/discount/${encodeURIComponent(
      selection.discountCode
    )}?redirect=/checkout`;

  return;
}

window.location.href = '/checkout';

          } catch (error) {
            console.error(
              '[Quantity Breaks]',
              error
            );

            alert(
              error.message ||
              'A apărut o eroare. Încearcă din nou.'
            );

            button.dataset.qbProcessing =
              'false';
          }
        },
        true
      );
    };


    /* =====================================================
       INITIALIZE
    ===================================================== */

    updateAll();

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        setupPageFlyBuyNow,
        { once: true }
      );
    } else {
      setupPageFlyBuyNow();
    }
  };


  /* =======================================================
     GLOBAL INIT
  ======================================================= */

  const init = () => {
    document
      .querySelectorAll(
        '[data-quantity-breaks]'
      )
      .forEach(initQuantityBreaks);
  };


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

})();